import { EntityInfo } from "@app/entity/model/entityinfo";
import { ActionPayloadGeneric } from "@app/root-store/actions";
import {
    createActionSet,
    createCrudActionSets,
    createDeletePromptActionSet,
    createNoPropsAction,
} from "@app/root-store/actions/action-creators";
import { TypedAction } from "@ngrx/store/src/models";

const actionCategory = "Entity Info";

export type ActionPayload = { entityinfo: EntityInfo } & ActionPayloadGeneric;

export interface LoadActionPayload {
    entityId: number;
    entityInfoType?: string;
}
export interface BulkActionResult {
    entityinfos: EntityInfo[];
}
export interface ActionResult {
    entityinfo: EntityInfo;
}

export type EntityInfoAction = ActionPayload & TypedAction<string>;

/**
 * Create the CRUD set of actions associated with the action category.
 * Must send in appropriate payload types for a single and load and result types for single and bulk.
 * A request, success and failure action are created for each CRUD operation.
 * Each action set should be deconstructed into consts from the result.
 */
export const {
    load: loadSet,
    create: createSet,
    update: updateSet,
    delete: deleteSet,
} = createCrudActionSets<ActionPayload, LoadActionPayload, ActionResult, BulkActionResult>(actionCategory);

export const clearEntityInfoState = createNoPropsAction(actionCategory, "Clear");

/**
 * An action set to prompt a user when deleting an item
 */
export const { confirm: deleteConfirmation, dismiss: deleteConfirmationDismiss } =
    createDeletePromptActionSet<ActionPayload>(actionCategory);

export const deleteConfirmationSet = { ...deleteSet, deleteConfirmation, deleteConfirmationDismiss };

export const silentDeleteSet = createActionSet<ActionPayload, ActionResult>(actionCategory, "Delete Silently");
